import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_b2ceecb0-da08-477c-bdbc-45b3f8bca466/artifacts/inshyz6k_PG%20New%20Logo%20%281%29.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSectionClick = (e, sectionId) => {
    e.preventDefault();
    
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth'
        });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  };
  
  const handleLogoClick = (e) => {
    e.preventDefault();
    
    if (location.pathname === '/') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 100);
    }
  };
  
  return (
    <footer className="footer py-16 pb-24 md:pb-16">
      <div className="container px-4 sm:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <a href="/" onClick={handleLogoClick} className="cursor-pointer inline-block">
              <img 
                src={LOGO_URL} 
                alt="Overflow Nation" 
                className="h-12 w-auto mb-6 opacity-90 hover:opacity-100 transition-opacity"
              />
            </a>
            <p className="body-regular text-gray-400 mb-4 max-w-sm">
              Protection Guardianship™ — A structured system that turns confusion into calm clarity.
            </p>
            <p className="body-small text-[var(--gold-primary)]">
              Not selling insurance. Building certainty.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="body-regular font-medium text-white mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="/#pathway" 
                  onClick={(e) => handleSectionClick(e, 'pathway')}
                  className="body-small hover:text-[var(--gold-primary)] transition-colors"
                >
                  The Pathway
                </a>
              </li>
              <li>
                <a 
                  href="/#deliverables" 
                  onClick={(e) => handleSectionClick(e, 'deliverables')}
                  className="body-small hover:text-[var(--gold-primary)] transition-colors"
                >
                  Deliverables
                </a>
              </li>
              <li>
                <a 
                  href="/#about" 
                  onClick={(e) => handleSectionClick(e, 'about')}
                  className="body-small hover:text-[var(--gold-primary)] transition-colors"
                >
                  About Joseph
                </a>
              </li>
              <li>
                <a 
                  href="/#faqs" 
                  onClick={(e) => handleSectionClick(e, 'faqs')}
                  className="body-small hover:text-[var(--gold-primary)] transition-colors"
                >
                  FAQs
                </a>
              </li>
            </ul>
          </div>
          
          {/* Tiers */}
          <div>
            <h4 className="body-regular font-medium text-white mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://wa.me/9172096199" target="_blank" rel="noopener noreferrer" className="body-small hover:text-[var(--gold-primary)] transition-colors">
                  Clarity Call (Free)
                </a>
              </li>
              <li>
                <a href="https://rzp.io/rzp/rTrzU8M" target="_blank" rel="noopener noreferrer" className="body-small hover:text-[var(--gold-primary)] transition-colors">
                  Blueprint Session
                </a>
              </li>
              <li>
                <a href="https://rzp.io/rzp/I2qAj82" target="_blank" rel="noopener noreferrer" className="body-small hover:text-[var(--gold-primary)] transition-colors">
                  Protection Assurance™
                </a>
              </li>
              <li>
                <a href="https://rzp.io/rzp/YftyTmw" target="_blank" rel="noopener noreferrer" className="body-small hover:text-[var(--gold-primary)] transition-colors">
                  Family Charter™
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Divider */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col md:flex-row items-center gap-4">
              <p className="body-small text-gray-500">
                © {currentYear} Overflow Nation. All rights reserved.
              </p>
              <div className="flex gap-4 body-small">
                <a 
                  href="https://sites.google.com/view/guardianship-privacy/home" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[var(--gold-primary)] hover:text-[var(--gold-dark)] transition-colors"
                >
                  Privacy Policy
                </a>
                <span className="text-gray-600">•</span>
                <a 
                  href="https://sites.google.com/view/protection-guardianshiptc/home" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[var(--gold-primary)] hover:text-[var(--gold-dark)] transition-colors"
                >
                  Terms & Conditions
                </a>
              </div>
            </div>
            <p className="body-small text-gray-600">
              Protection Guardianship™ is a trademark of Overflow Nation.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
